import { getLocale } from "../runtime";

const sv_waresplural = /** @type {(inputs: {value: NonNullable<unknown>}) => string} */ (inputs) => {
	return `${inputs.value} varor`
};

const waresplural = /** @type {(inputs: {value: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_waresplural(inputs)
	return "waresPlural";
};

export { waresplural as "waresPlural" };